import { ReactNode } from 'react';
import { css } from '@emotion/react';
import { breakpoints } from '@frontend/responsiveness';
import { theme } from '@frontend/theme';

const styles = {
  pageContainer: css`
    display: flex;
    flex-flow: column;
    width: 100%;
    height: 100%;
    justify-content: space-between;
    align-items: center;
    padding-bottom: ${theme.spacing(2)};
    background-color: ${theme.colors.neutral5};
    overflow-y: scroll;
  `,
  portalContainer: css`
    display: flex;
    flex-flow: column;
    padding: ${theme.spacing(2)};
    margin: 0 auto;
    width: 100%;
    @media (min-width: ${breakpoints.small.min}px) {
      width: 544px;
      position: relative;
      height: max-content;
      top: ${theme.spacing(4.5)};
    }
  `,
  footer: css`
    padding-top: ${theme.spacing(2)};
    padding-bottom: ${theme.spacing(2)};
    text-align: center;
    margin-top: ${theme.spacing(2)};
    a {
      text-decoration: none;
      color: ${theme.font.colors.subdued};
    }
    a:hover {
      color: ${theme.font.colors.default};
    }
  `,
};
interface PortalPageWrapperProps {
  children: ReactNode;
  Footer?: ReactNode;
}

export const PortalPageWrapper = ({ children, Footer }: PortalPageWrapperProps) => {
  return (
    <div css={styles.pageContainer}>
      <div css={styles.portalContainer}>{children}</div>
      <div css={styles.footer}>{Footer}</div>
    </div>
  );
};
